import { makeStyles } from '@mui/styles';
import { neutral7, primary, purple } from 'apollo-react/colors';
import DonutChart from 'apollo-react/components/DonutChart';
import Grid from 'apollo-react/components/Grid';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getTaskCountByStatus } from '../../../../actions/TaskCountByStatusActions';
import withTranslation from '../../../../components/withTranslation';

const useStyles = makeStyles({
  root: {
    paddingTop: '10%',
  },
  numberContainer: {
    color: primary,
    textAlign: 'center',
    position: 'relative',
    top: '-13px',
  },
  numberContainer1: {
    color: purple,
  },
  numberContainer2: {
    color: neutral7,
  },
  lgNumberlabel: {
    fontSize: '1.7rem',
  },
  smNumberlabel: {
    fontSize: '1rem',
    position: 'relative',
    top: '-10px',
  },
  errorMsg: {
    paddingTop: '50px',
    color: primary,
  },
});

const DashboardPartDonutChart = ({ tab, translateString }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const taskCountByStatus = useSelector((state) => state.taskCountByStatus);

  const { days } = tab.graph;
  const { overDue = 0, toDo = 0, completed = 0 } = taskCountByStatus.data;
  const [completion, setCompletion] = useState(0);

  useEffect(() => {
    dispatch(getTaskCountByStatus({ days }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [days]);

  useEffect(() => {
    if (completed) {
      const total = overDue + toDo + completed;
      setCompletion(Math.floor((completed / total) * 100));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [completed]);

  return (
    <Grid
      container
      direction="row"
      justify="center"
      alignItems="center"
      className={classes.root}
      justifyContent="center"
    >
      <Grid className={classNames(classes.numberContainer, classes.numberContainer1)}>
        <div className={classes.lgNumberlabel}>{overDue + toDo}</div>
        <div className={classes.smNumberlabel}>{translateString('To Do')}</div>
      </Grid>
      <Grid>
        <DonutChart percent={completion} stroke="#0768fd" subtitle=" " dropshadow />
      </Grid>
      <Grid className={classNames(classes.numberContainer, classes.numberContainer2)}>
        <div className={classes.lgNumberlabel}>{completed}</div>
        <div className={classes.smNumberlabel}>{translateString('Completed')}</div>
      </Grid>
    </Grid>
  );
};

export default withTranslation(DashboardPartDonutChart);
